const errorMessage = 'Por favor, ingrese su correo electrónico y contraseña.';

export const createLoginErrorSlice = (set) => ({
  loginErrorMessage: errorMessage,
  setLoginErrorMessage: (loginErrorMessage) => set({ loginErrorMessage }),
  resetLoginError: () => set({ loginErrorMessage: errorMessage })
});
